import { Reducer } from "redux";
import { SiteStructureActionTypes, IStructureActions } from "./site-structure.actions";
import { ISiteStructureContainerState } from "./site-structure";

export const initialStructureState: ISiteStructureContainerState = {};

export const siteStructureReducer: Reducer<ISiteStructureContainerState, IStructureActions> = (state = initialStructureState, action) => {
    switch (action.type) {
        case SiteStructureActionTypes.SITE_STRUCTURE_FETCH_SUCCESS: {
            return {
                ...state,
                ...action.siteStructure,
            };
        }
        default:
            return state;
    }
};
